import PropTypes from "prop-types";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import EditRoleForm from "routes/admin/components/EditRoleForm";

const EditRoleModal = ({ open, onOpenChange, userIds, onSuccess }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Change User roles</DialogTitle>
      </DialogHeader>
      {open && (
        <EditRoleForm
          userIds={userIds}
          onSuccess={onSuccess}
          onCancel={() => onOpenChange(false)}
        />
      )}
    </DialogContent>
  </Dialog>
);

EditRoleModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  userIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default EditRoleModal;
